// NotificationCenter.jsx
import { useNotifications } from "../stores/NotificationsStore";
import "./NotificationCenter.css"; // 記得引入 CSS 檔

export default function NotificationCenter() {
  const { items, remove } = useNotifications();

  return (
    <div className="notification-center">
      {items.map((n) => (
        <div key={n.id} className="notification">
          <div className="notification-body">
            <div className="notification-title">{n.title}</div>
            {n.message && (
              <div className="notification-message">{n.message}</div>
            )}

            {n.actions?.length > 0 && (
              <div className="notification-actions">
                {n.actions.map((btn) => (
                  <button
                    key={btn.label}
                    onClick={() => {
                      // 若 action 指定 keepOpen=true，就不自動移除
                      btn.onClick?.();
                      if (!btn.keepOpen) remove(n.id);
                    }}
                    className="notification-button"
                  >
                    {btn.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          <button
            onClick={() => remove(n.id)}
            className="notification-close"
            aria-label="關閉通知"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
